"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakpointsManager = void 0;
const event_1 = require("@zajno/common/observing/event");
const logger_1 = require("@zajno/common/logger");
const rem_1 = require("./rem");
const logger = (0, logger_1.createLogger)('[Breakpoints]');
class BreakpointsManager {
    constructor() {
        this._remChanged = new event_1.Event();
        this._breakpointChanged = new event_1.Event();
        this._list = [];
        this._state = {
            width: 0,
            height: 0,
            currentBreakpoint: null,
            currentRem: 0.0,
        };
    }
    registerBreakpoint(bp) {
        const existing = this._list.findIndex(b => b.id === bp.id);
        if (existing >= 0) {
            this._list[existing] = bp;
        }
        else {
            this._list.push(bp);
            this._list.sort((b1, b2) => b1.id - b2.id);
        }
    }
    get breakpoint() { return this._state.currentBreakpoint; }
    get rem() { return this._state.currentRem; }
    get width() { return this._state.width; }
    get height() { return this._state.height; }
    get breakpointChanged() { return this._breakpointChanged; }
    get remChanged() { return this._remChanged; }
    resize(width, height) {
        let bp = this._list.find(b => window.matchMedia(b.mediaQuery).matches);
        if (!bp) {
            bp = this._list[0];
        }
        this._state.width = width;
        this._state.height = height;
        const rem = (0, rem_1.calcRem)(width, height, bp);
        logger.log('Current breakpoint:', `[${width}x${height}]`, bp, '; rem =', rem);
        if (!this._state.currentBreakpoint || this._state.currentBreakpoint.id !== bp.id) {
            this._state.currentBreakpoint = bp;
            this._breakpointChanged.trigger(bp);
        }
        if (this._state.currentRem !== rem) {
            this._state.currentRem = rem;
            this._remChanged.trigger(rem);
        }
    }
}
exports.BreakpointsManager = BreakpointsManager;
//# sourceMappingURL=manager.js.map